import {createSilentAudio} from "create-silent-audio";

var cloneDeep = require('lodash/cloneDeep');
var Promise = require('promise');

import EventEmitter from '../helpers/EventEmmiter';
import Timeout from '../helpers/timeout';
import detectBrowser from 'a_common-folder/utils/detectBrowser';
import {addVideoBubble} from 'lib/service/html.service';
import Loading from 'lib/loading';

class PlayerService extends EventEmitter {
    constructor(options, isIOS = false, container) {
        super();
        this._timeout = new Timeout();
        this._isIOS = isIOS;
        this._options = cloneDeep(options);
        // if (!this._options.audio && !this._options.video ) {
        //     throw new Error('No file in e3 player');
        // }
        if (!this._options.commands || !this._options.commands.length) {
            throw new Error('No commands in e3 player');
        }

        this._media = null;
        this._isPaused = false;
        this._interrupted = null;
        this._mediaEvents = [];

        this._commands = this._options.commands.map(function (c, i) {
            c.index = i;
            c.animation.start /= 1000;
            c.animation.end /= 1000;
            c.animation.duration = c.animation.end-c.animation.start;
            c.time /= 1000;
            return c;
        });
        this.container = container;
        this._videoBubble = null;

        this._loading = new Loading(this.container, 'loading-without-text');
        this._loading.show();

        this._initAudio(this._options);
    }

    getAudioSrc() {
        return this._options.audio;
    }

    getFileSrc() {
        return this._media.src;
    }

    getFileElement() {
        return this._media;
    }

    getAudioElement() {
        return this._media;
    }

    getAudioDuration() {
        return this._media.duration;
    }

    play() {
        const res = this._media.play();

        this._isPaused = false;
        if (res && res.catch) {
            res.catch(function (e) {
                // code 20 – DOMException: The play() request was interrupted by a call to pause(). https://goo.gl/LdLk22
                if (e && e.code === 20) return;
                this._playMuted();
                // this._fireEvent('error.user-action', 'AUDIO_MANUAL_PLAY_NEEDED');
                // console.info('You have to start e3play record manually by clicking on play button');
            }.bind(this));
        }
        //check eventListener 'playing'
    }

    pause(globalState) {
        if (typeof globalState === 'boolean' && globalState) {
            this._isPaused = true;
        }
        if (this._media.paused) return;
        // if (!this._media.paused && typeof globalState === 'undefined') return;
        this._media.pause();
    }

    isPlaying() {
        return !this._isPaused;
    }

    destroy() {
        EventEmitter.prototype.destroy.call(this);
        this._options = null;
        var removeListener = function (evData) {
            this._media.removeEventListener.apply(this._media, evData);
        }.bind(this);
        this._mediaEvents.forEach(removeListener);
        this._mediaEvents = null;
        this._media.pause();
        this._media.src = '';
        this._media.load();
        this._media = null;
        if (this._timeout) this._timeout.reset();
        if(this._videoBubble) this._removeVideoBlock();
        if(this._loading) this._loading.destroy();
    }


    addVideoBlock(){
        const bubble = addVideoBubble(this.getFileElement());
        this._videoBubble = bubble;

        this.container.appendChild(bubble);
    }

    _removeVideoBlock(){
        this.container.removeChild(this._videoBubble);
    }

    _playMuted() {
        this._media.muted = true;

        this._fireEvent('muted');

        return this._media.play();
    }

    _scheduleCommand(index) {
        var state = this._commands[index], timeout;
        if (!state) {
            return;
        }

        timeout = Math.max(state.animation.start - this._media.currentTime, 0) * 1000;

        // var expected = (window.performance ? window.performance.now() : Date.now()) + (state.animation.start - this._media.currentTime) * 1000;

        function loop(state, nextIndex) {
            this._stateIndex = state.index;
            // var delay = (window.performance ? window.performance.now() : Date.now()) - expected;
            // console.log(state.index + ' Delta: ' + delay);
            if (this._timeout) this._timeout.reset();
            this._fireEvent('statechange', cloneDeep(state));
            if (this._commands[nextIndex]) {
                this._scheduleCommand(nextIndex);
            }

        }

        if (!timeout) {
            loop.call(this, state, index + 1);
        } else {
            this._timeout.set(loop.bind(this, state, index + 1), timeout);
        }

        return timeout;
    }


    _stopCommands() {
        if (this._timeout){
            this._timeout.reset();
            // FF fix bug with stop e3play onmousemove
            if(detectBrowser.isFirefox){
                setTimeout(() => this._timeout.reset(),100)
            }
        }
    }

    _findState() {
        var seconds = this._media.currentTime;
        var command, prev, state, perc;
        for (var i = this._commands.length - 1; i >= 0; i--) {
            command = this._commands[i];

            if (seconds >= command.animation.start) {
                if (seconds >= command.animation.end) {
                    state = cloneDeep(command);
                    state.index = i;
                    return state;
                }
                prev = this._commands[i - 1];
                state = cloneDeep(command);
                perc = (seconds - command.animation.start) / command.animation.duration;
                state.index = i - 1 + perc;
                state.current = {
                    hfov: (command.hfov - prev.hfov) * perc + prev.hfov,
                    yaw: (command.yaw - prev.yaw) * perc + prev.yaw,
                    pitch: (command.pitch - prev.pitch) * perc + prev.pitch,
                    scene: command.scene,
                    animation: {duration: 0, start: seconds}
                };
                state.animation.start = seconds;
                state.animation.duration = command.animation.end - seconds;
                return state;
            }
        }
    }

    setVolume(volume) {
        this._media.muted = !volume;
        this._media.volume = volume;
    }

    setTime(seconds) {
        this._media.currentTime = seconds;
        var state = this._findState();
        if (state.current) {
            state = state.current;
        }

        return state;
    }

    setInterrupted(state) {
        this._interrupted = cloneDeep(state);
        this._interrupted.animation = {duration: 0};
    }

    getInterrupted() {
        return this._interrupted;
    }

    clearInterrupted() {
        this._interrupted = null;
    }

    _initAudio({audio, video}) {
        let src = audio || video;
        if(!src) src = createSilentAudio(Math.round(this._commands[this._commands.length - 1].animation.end), 44100);

        // this.isAudioReady = false;
        this.audioReady = new Promise(function (resolve, reject) {

            var onBufferChange = function () {
                this._fireEvent('buffer.change', this._media.buffered.length ? this._media.buffered.end(0) / this._media.duration : 0);
            }.bind(this);

            this._mediaEvents.push(
                [
                    'loadedmetadata',
                    async function () {
                        // console.info('loadedmetadata');
                        var initialState = this.setTime(0);
                        //resetting duration to immediately open viewer to appropriate position
                        // initialState.animation.duration = 0;

                        while(this._media.duration === Infinity) {
                            await new Promise(r => setTimeout(r, 1000));
                            this._media.currentTime = 10000000*Math.random();
                        }
                        this._media.currentTime = 0;
                        if(video) this.addVideoBlock();
                        this._loading.hide();

                        this._fireEvent('loadedmetadata', initialState);
                    }.bind(this)
                ],
                [
                    'canplay',
                    function () {

                        // console.info('canplay');
                        this.isAudioReady = true;
                        resolve();
                    }.bind(this)
                ],
                [
                    'playing',
                    function () {
                        // console.info('playing');
                        this._fireEvent('playing', this._media.currentTime);
                        if (!this._stateIndex) {
                            var state = this._findState();
                            this._stateIndex = Math.floor(state.index);
                            if (state.index % 1) {
                                this._fireEvent('statechange', state);
                            }
                        }
                        this._scheduleCommand(this._stateIndex + 1);
                    }.bind(this)
                ],
                [
                    'pause',
                    function () {
                        // console.info('pause');
                        this._stopCommands();
                        this._fireEvent('pause', this._media.currentTime === this._media.duration ? 0 : this._media.currentTime);
                        this._stateIndex = null;
                    }.bind(this)
                ],
                [
                    'error',
                    function (e) {
                        // console.info('error');
                        if(this._loading) this._loading.destroy();
                        this.isAudioReady = false;
                        reject(e);
                    }.bind(this)
                ],
                [
                    'ended',
                    function () {
                        // console.info('ended');
                        this._media.currentTime = 0;
                        this._isPaused = true;
                        this._fireEvent('statechange', this._findState());
                        this._fireEvent('ended');
                    }.bind(this)
                ],
                [
                    'timeupdate',
                    function (e) {
                        // console.info('timeupdate');
                        this._fireEvent('timechange', this._media.currentTime, !this._media.paused);
                    }.bind(this)
                ],
                [
                    'waiting',
                    function () {
                        // console.info('waiting');
                        // this._stopCommands();
                        this._fireEvent('waiting', this._media.currentTime);
                    }.bind(this)
                ],
                // [
                //     'seeking',
                //     function () {
                //         console.info('seeking');
                //     }
                // ],
                // [
                //    'seeked',
                //    function () {
                //        console.info('seeked');
                //    }
                // ],
                [
                    'progress',
                    function () {
                        // console.log('progress');
                        onBufferChange();
                    }
                ],
                [
                    'loadeddata',
                    function () {
                        // console.log('loadeddata');
                        onBufferChange();
                    }
                ]
            );
            var addListener = function (evData) {
                this._media.addEventListener.apply(this._media, evData);
            }.bind(this);
            /**
             * The reason of using <video> instead <audio> – chrome autoplay policy
             * https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
             *
             * Can't run muted audio without user gesture (related to Chrome only)
             * In case of iOS device we have ability operates only with <audio> tag
             */
            // let media = this._isIOS ? document.createElement('audio') : document.createElement('video');
            let media = document.createElement('video');
            media.setAttribute('playsinline', 'playsinline');

            this._media = media;
            media.playsinline  = true;
            media.preload = 'auto';
            media.playbackRate = 1.0;
            this._mediaEvents.forEach(addListener);
            media.src = src;
            media.load();

        }.bind(this));
    }
}


export default PlayerService;
